/**
 * @module: com.inq.flash.client.control
 * @class: WebRTCMgr
 * @constructor
 */
com.inq.flash.client.control.WebRTCMgr = function() {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.WebRTCMgr.engageAudio",wMgr.engageAudio);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.WebRTCMgr.isWebRTCCapable",wMgr.isWebRTCCapable);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.WebRTCMgr.endCall",wMgr.endCall);
};
$hxClasses.registerClass(com.inq.flash.client.control.WebRTCMgr, "com.inq.flash.client.control.WebRTCMgr");

/*
 * @description: init function will register click event handler on various video chat elements
 * @static
 * @public
 */
com.inq.flash.client.control.WebRTCMgr.init = function (audioOnly) {

	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var getMxmlItem = wMgr.getElement;
	var _chat = com.inq.flash.client.chatskins.SkinControl.getApplicationController().chat;
	var getConfig = com.inq.utils.Util.getConfig;
	var clientVEl = getMxmlItem("clientVideo",audioOnly);
	var agentVEl = getMxmlItem("agentVideo",audioOnly);
	var startCallEl = getMxmlItem("btnStartCall",audioOnly);
	var endCallEl = getMxmlItem("btnEndCall",audioOnly);
	var muteCallBtn = getMxmlItem("btnMuteCall",audioOnly);
	var unMuteCallBtn = getMxmlItem("btnUnMuteCall",audioOnly);
	var restartBtn = getMxmlItem("callRestart", audioOnly);

	wMgr.chatInfo = {
		chatId: _chat.chatID,
		agentName: _chat.agentName,
		siteId: _chat.getSiteID(),
		customerId: _chat.thisCustomerID,
		reconnectMsg:getConfig("webCallReconnecting", "WebCall reconnecting...")
	};
	wMgr.webCallConnecting = wMgr.webCallConnecting || getMxmlItem("callConnecting",audioOnly);
	wMgr.webCallInProgress = wMgr.webCallInProgress || getMxmlItem("callProgress",audioOnly);
	wMgr.webCallError = wMgr.webCallError || getMxmlItem("callError",audioOnly);
	wMgr.webCallRecon = wMgr.webCallRecon || getMxmlItem("callReconnect", audioOnly);
	wMgr.webCallPDen =  wMgr.webCallPDen || getMxmlItem("callDenied", audioOnly);
	wMgr.webCallCanvas = wMgr.webCallCanvas || getMxmlItem("webCall", audioOnly);


	wMgr.clientVideoElement = wMgr.clientVideoElement ||
							  clientVEl && clientVEl._div.getElementsByTagName("video")[0] || clientVEl._div;
	wMgr.agentVideoElement = wMgr.agentVideoElement ||
		agentVEl && agentVEl._div.getElementsByTagName("video")[0] || agentVEl._div;
	if (agentVEl && agentVEl.getVisible()) {
		wMgr.audioOnlyChat = false;
	}

	if (startCallEl) {
		startCallEl.removeEventListener("click", wMgr.actionStartCall)
		startCallEl.addEventListener("click",wMgr.actionStartCall);
	}
	if(restartBtn) {
		restartBtn.removeEventListener("click", wMgr.actionStartCall)
		restartBtn.addEventListener("click", wMgr.actionStartCall);
	}
	if (endCallEl) {
		endCallEl.removeEventListener("click", wMgr.actionEndCall)
		endCallEl.addEventListener("click", wMgr.actionEndCall);
	}
	if (muteCallBtn) {
		muteCallBtn.removeEventListener("click", wMgr.mute)
		muteCallBtn.addEventListener("click", wMgr.mute);
	}
	if (unMuteCallBtn) {
		unMuteCallBtn.removeEventListener("click", wMgr.unmute)
		unMuteCallBtn.addEventListener("click", wMgr.unmute);
	}
	wMgr.webCallEndCallBtn =  wMgr.webCallEndCallBtn || endCallEl;
	wMgr.webCallStartCallBtn = wMgr.webCallStartCallBtn || startCallEl;
	wMgr.webCallRestartBtn = wMgr.webCallRestartBtn || restartBtn;
	wMgr.muteBtn = wMgr.muteBtn || muteCallBtn;
	wMgr.unmuteBtn = wMgr.unmuteBtn || unMuteCallBtn;

};
com.inq.flash.client.control.WebRTCMgr.mute = function() {
	if(window.top.WebRTCApp || window.WebRTCApp) {
		if(window.WebRTCApp){
			window.WebRTCApp.muteCall();
		} else {
			window.top.WebRTCApp.muteCall();
		}
	} else if(WebRTCMgr.getAndSDKInst()){
		WebRTCMgr.getAndSDKInst().muteCall();
	} else if(!!WebRTCMgr.isIOSSDK()) {
		WebRTCMgr.isIOSSDK().postMessage("mute");
	}

	WebRTCMgr.toggleElState(WebRTCMgr.muteBtn,false);
	WebRTCMgr.toggleElState(WebRTCMgr.unmuteBtn,true);
};
com.inq.flash.client.control.WebRTCMgr.unmute = function() {
	if(window.top.WebRTCApp || window.WebRTCApp) {
		if(window.WebRTCApp){
			window.WebRTCApp.unMuteCall();
		} else {
			window.top.WebRTCApp.unMuteCall();
		}
	} else if(WebRTCMgr.getAndSDKInst()){
		WebRTCMgr.getAndSDKInst().unMuteCall();
	} else if(!!WebRTCMgr.isIOSSDK()) {
		WebRTCMgr.isIOSSDK().postMessage("unMute");
	}

	WebRTCMgr.toggleElState(WebRTCMgr.muteBtn,true);
	WebRTCMgr.toggleElState(WebRTCMgr.unmuteBtn,false);
};

com.inq.flash.client.control.WebRTCMgr.accessConstrants = function(audio,video) {
	if (navigator.mediaDevices === undefined) {
		navigator.mediaDevices = {};
	}
	if (navigator.mediaDevices.getUserMedia === undefined) {
		navigator.mediaDevices.getUserMedia = function (constraints) {
			var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
			return new Promise(function(resolve, reject) {
				getUserMedia.call(navigator, constraints, resolve, reject);
			});
		}
	}
	return navigator.mediaDevices.getUserMedia({ audio: audio, video: video });
};
com.inq.flash.client.control.WebRTCMgr.initSounds = function () {
	var sndD = com.inq.utils.Util.getConfig("callDisconnectSnd",null), sndRing = com.inq.utils.Util.getConfig("callDial",null);
	if (sndD) {
		com.inq.flash.client.control.WebRTCMgr.disSnd = com.inq.flash.client.chatskins.SndMgr.initIosAudio(com.inq.flash.client.chatskins.SndMgr.soundSrc(sndD));
	}
	if(sndRing) {
		com.inq.flash.client.control.WebRTCMgr.ringSnd = com.inq.flash.client.chatskins.SndMgr.initIosAudio(com.inq.flash.client.chatskins.SndMgr.soundSrc(sndRing),true);
	}
};

com.inq.flash.client.control.WebRTCMgr.initAudioCall = function () {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if (wMgr.webCallStatus === "progress" || wMgr.isEngaged) return;
	wMgr.resetElState();
	wMgr.close();
	wMgr.audioOnlyChat = true;
	wMgr.init(true);
};

com.inq.flash.client.control.WebRTCMgr.initVideoCall = function () {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if (wMgr.webCallStatus === "progress" || wMgr.isEngaged) return;
	wMgr.resetElState();
	wMgr.close();
	wMgr.init();
};

com.inq.flash.client.control.WebRTCMgr.engageAudio = function (chatParams){
	chatParams["wCall"] = "audio";
	var xw = com.inq.flash.client.control.XFrameWorker;
	chatParams["agentOutcome"] = xw.DO_NOT_DISPLAY_IN_CI + xw.findCustomerName(chatParams["agentOutcome"]);
	if(xw.redirectToNativeSDK(chatParams)) {
		return;
	}
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if(wMgr.isEngaged) return;
	wMgr.initAudioCall();
	wMgr.engageElStatus(true, false, chatParams);
	com.inq.flash.client.control.PersistenceManager.SetValue(WEB_CALL_MODE, WebRTCMgr.AUDIO_CALL);
};

com.inq.flash.client.control.WebRTCMgr.engageCall = function (chatParams){
	var sc = com.inq.flash.client.chatskins.SkinControl;
	if(sc.getApplicationController().isConnected()){
		com.inq.flash.client.control.WebRTCMgr.sendStartCallMessage();
		return;
	}

	sc.applicationController.processClickToWebCallQueueMessages(chatParams);
	sc.StopTimer();
	com.inq.flash.client.control.WebRTCMgr.ringSnd && com.inq.flash.client.control.WebRTCMgr.ringSnd.audio.play();
};
com.inq.flash.client.control.WebRTCMgr.engageElStatus = function (isAudio, reload, chatParams) {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var cForm = wMgr.getElement("webCall",isAudio);
	wMgr.webCallStatus = "started";
	wMgr.isEngaged = true;
	wMgr.toggleElState(cForm,true);
	wMgr.toggleElState(wMgr.webCallConnecting, true);
	if(reload)return;
	if(chatParams) {
		wMgr.closeOnEnd =  chatParams["closeOnEnd"];
	}
	var aH = com.inq.flash.client.chatskins.SkinControl.accessibilityHelp;
	if(aH.isAccessibilityHelpOnBtnSend) {
		aH.removeHelpOnBtnSend();
	}
	if(wMgr.getAndSDKInst()){
		wMgr.automatonParams = chatParams;
		wMgr.getAndSDKInst().checkPermission();
		return;
	}
	if(!!wMgr.isIOSSDK()){
		wMgr.automatonParams = chatParams;
		wMgr.isIOSSDK().postMessage("checkPermission");
		return;
	}
	/*wMgr.accessConstrants(true,!isAudio).then(function(s){
		if(s && s.getTracks().length>0) {
			s.getTracks()[0].stop();
		}*/
		if (window.top.WebRTCApp || window.WebRTCApp) {
			wMgr.engageCall(chatParams);
		} else {
			wMgr.automatonParams = chatParams;
			com.inq.flash.client.control.FlashPeer.loadKMSlibraries();
		}
	/*}).catch(function(){
		com.inq.flash.client.control.XFrameWorker.engageChat(chatParams);
		setTimeout(function(){
			wMgr.onError("perDenied");
		},2000);
	});*/

};

com.inq.flash.client.control.WebRTCMgr.engageVideo = function (chatParams){
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if(wMgr.isEngaged) return;
	wMgr.initVideoCall();
	wMgr.engageElStatus(false, false, chatParams);
	com.inq.flash.client.control.PersistenceManager.SetValue(WEB_CALL_MODE, WebRTCMgr.VIDEO_CALL);
};

/**
 * @description this method will be called upon closing the chat.
 */
com.inq.flash.client.control.WebRTCMgr.close = function () {
	var webRTCMgr = com.inq.flash.client.control.WebRTCMgr;
	if (webRTCMgr.webCallStatus === "progress" || webRTCMgr.webCallStatus == "restarted") {
		webRTCMgr.endCall();
	} else if(webRTCMgr.webCallStatus === "started") {
		webRTCMgr.sendWebCallEndMessage(WebRTCMgr.CALL_LEFT_MSG, webRTCMgr.isCustomerEndsChat, true);
	}
	webRTCMgr.ringSnd && webRTCMgr.ringSnd.audio.pause();
	webRTCMgr.webCallStatus = "";
	if (webRTCMgr.webCallEndCallBtn) {
		webRTCMgr.webCallEndCallBtn.removeEventListener("click", webRTCMgr.actionEndCall);
		webRTCMgr.webCallEndCallBtn = null;
	}
	if (webRTCMgr.webCallStartCallBtn) {
		webRTCMgr.webCallStartCallBtn.removeEventListener("click", webRTCMgr.actionStartCall);
		webRTCMgr.webCallStartCallBtn = null;
	}
	if(webRTCMgr.webCallRestartBtn) {
		webRTCMgr.webCallRestartBtn.removeEventListener("click", webRTCMgr.actionStartCall);
		webRTCMgr.webCallRestartBtn = null;
	}
	if(webRTCMgr.muteBtn) {
		webRTCMgr.muteBtn.removeEventListener("click", webRTCMgr.mute);
	}
	if(webRTCMgr.unmuteBtn) {
		webRTCMgr.unmuteBtn.removeEventListener("click", webRTCMgr.unmute);
	}

	webRTCMgr.webCallConnecting = null;
	webRTCMgr.webCallInProgress = null;
	webRTCMgr.webCallError = null;
	webRTCMgr.clientVideoElement = null;
	webRTCMgr.agentVideoElement = null;
	webRTCMgr.webCallPDen = null;
	webRTCMgr.isEngaged = false;
	webRTCMgr.ringSnd && webRTCMgr.ringSnd.audio.pause();
	clearTimeout(webRTCMgr.timerID);

};

/**
 * @description this method will either send a webcall message to agent or load the kms libraries.
 */
com.inq.flash.client.control.WebRTCMgr.actionStartCall = function () {
	var wMgr  = com.inq.flash.client.control.WebRTCMgr;
	if (wMgr.webCallStatus == "started") {
		return;
	}
	wMgr.toggleElState(wMgr.webCallConnecting, true);
	wMgr.webCallStatus = "started";
	wMgr.ringSnd && wMgr.ringSnd.audio.play();
	if (window.top.WebRTCApp || window.WebRTCApp) {
		wMgr.incrementCount();
		wMgr.sendStartCallMessage();
	} else if( !!wMgr.isIOSSDK()) {
		wMgr.isIOSSDK().postMessage("checkPermission");
	} else if(wMgr.getAndSDKInst()) {
		wMgr.getAndSDKInst().checkPermission();
	} else {
		com.inq.flash.client.control.FlashPeer.loadKMSlibraries();
	}
};

com.inq.flash.client.control.WebRTCMgr.iosSDKperGrant = function() {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var sc = com.inq.flash.client.chatskins.SkinControl;
	 if(wMgr.automatonParams) {
		wMgr.engageCall(wMgr.automatonParams);
	} else if(sc.isClick2WebCall() && !sc.getApplicationController().isConnected()) {
		sc.applicationController.processClickToWebCallQueueMessages();
	}  else {
		wMgr.sendStartCallMessage();
	}
};


com.inq.flash.client.control.WebRTCMgr.actionEndCall = function () {
	com.inq.flash.client.control.WebRTCMgr.isCustomerEndsChat = true;
	com.inq.flash.client.control.WebRTCMgr.endCall();
};

/**
 * @description end the active webcall
 */
com.inq.flash.client.control.WebRTCMgr.endCall = function(closeOnEnd){
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if (window.top.WebRTCApp || window.WebRTCApp) {
		if(window.WebRTCApp) {
			window.WebRTCApp.endCall();
		} else {
			window.top.WebRTCApp.endCall();
		}
	} else if(!!wMgr.isIOSSDK()) {
		wMgr.isIOSSDK().postMessage("endcall");
	} else if(wMgr.getAndSDKInst()) {
		wMgr.getAndSDKInst().endCall();
	}


	if(typeof closeOnEnd == "boolean")
		wMgr.closeOnEnd = closeOnEnd;

	if(wMgr.webCallStatus == "started" || wMgr.webCallStatus == "restarted") {
		wMgr.processCallEnded();
	}
};
/**
 * @description is an audio only webrtc call
 * @returns boolean
 */
com.inq.flash.client.control.WebRTCMgr.isAudioOnlyWebCall = function () {
	return com.inq.flash.client.control.WebRTCMgr.audioOnlyChat;
};

/**
  @description sending message to agent
  @param msgString String
 */
com.inq.flash.client.control.WebRTCMgr.sendWebCallMessage = function (msgString, action) {
	var controller = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	if (controller) {
		controller.sendWebCallMessage(msgString, action);
	}
};

com.inq.flash.client.control.WebRTCMgr.sendWebCallEndMessage = function (msgString, isCusEnd, abandoned) {
	var controller = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	if (controller) {
		controller.sendWebCallEndMessage(msgString, isCusEnd, abandoned);
	}
};

/**
 @description processing messages send by agent
 @param {String} msgAction
 */
com.inq.flash.client.control.WebRTCMgr.processAgentMessage = function (msgAction) {
	var msg = msgAction ? msgAction.split(",") : [], sMsg = "";
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var _status = wMgr.webCallStatus;
	if (msgAction.length < 3) return;
	switch (msg[0]) {
		case "room.created":
			if(wMgr.webCallStatus == "callerror") return;
			WebRTCMgr.isQueued = false;
			if ((window.top.WebRTCApp || window.WebRTCApp || wMgr.isIOSSDK() || wMgr.getAndSDKInst()) && com.inq.flash.client.control.PersistenceManager.GetValue(WEB_CALL_STARTED, 0) === 0) {
				wMgr.joinCall(msg[1], msg[2]);
				wMgr.sendWebCallMessage(com.inq.utils.Util.getConfig("webCallRoomCreated", "Agent joined the Room."),"");
			}
			break;
		case "networkErr":
			if(_status == "ended" || _status == "callerror") {
				wMgr.sendWebCallMessage("Customer closed call window. Please offer chat to customer.", "");
			}
			break;
		case "endWebcall":
			if(_status == "restarted" || _status=="started") {
				wMgr.webCallStatus = "callerror";
				wMgr.onError("WE");
			} else if(_status == "progress") {
					wMgr.webCallStatus = "ended";
					wMgr.endCall();
			}
			break;
		case "room.created.reconnect": {
			if(_status == "ended") return;
			//wMgr.webCallStatus = "restarted";
			if(msg[1] == "initing") {
				sMsg = com.inq.utils.Util.getConfig("webCallReconnecting", "WebCall reconnecting...");
				//com.inq.flash.client.control.PersistenceManager.SetValue("wcall", 0);
				//wMgr.onRestart(msg);
				wMgr.setErrorText(sMsg, "", true);
				wMgr.sendWebCallMessage(sMsg, "");
			} else if(msg[1] == "failed") {
				com.inq.flash.client.control.PersistenceManager.SetValue(WEB_CALL_STARTED, 0);
				wMgr.webCallStatus = "callerror";
				wMgr.onError("AI", msg[2]);
			} else if(msg[1] == "inited") {
				if(_status == "restarted" || _status == "callerror") return;
				wMgr.webCallStatus = "restarted";
				wMgr.processCallStarted();
			}
			break;
		}
	}
};

com.inq.flash.client.control.WebRTCMgr.joinCall = function (serverUrl,token) {
	var WebRTCApp = window.top.WebRTCApp || window.WebRTCApp;
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var pm = com.inq.flash.client.control.PersistenceManager;
	if (Inq.CHM.isV3Continue()  && wMgr.webCallStatus == "restarted") {
		wMgr.chatInfo.kurentoAppServerUrl = pm.GetValue(WEB_CALL_URL, WebRTCMgr.WEBRTC_URL);
		wMgr.chatInfo.authToken = pm.GetValue(WEB_CALL_AUTH_TOKEN, "");
	}

	if(wMgr.isIOSSDK()) {
		window.parent.webkit.messageHandlers.tcrtc.postMessage("startcall&"+wMgr.chatInfo.customerId+"&"+wMgr.chatInfo.chatId+"&"+wMgr.chatInfo.siteId+"&"+token+"&"+serverUrl);
	} else if(wMgr.getAndSDKInst()) {
		wMgr.getAndSDKInst().joinCall(JSON.stringify({"roomName": wMgr.chatInfo.chatId,"userName":wMgr.chatInfo.customerId,"siteID":wMgr.chatInfo.siteId,"token":token,"url":serverUrl}));
	} else {
		WebRTCApp.setOnErrorCb(wMgr.onError);
		WebRTCApp.setAudioOnly(wMgr.isAudioOnlyWebCall());
		WebRTCApp.setCallStartedCb(wMgr.processCallStarted);
		WebRTCApp.setCallEndedCb(wMgr.processCallEnded);
		WebRTCApp.setOnDisconnectCb(wMgr.onDisconnect);
		WebRTCApp.setServerTmeoutCb(wMgr.onTimeout);
		wMgr.chatInfo.kurentoAppServerUrl = serverUrl;

		if((com.inq.utils.Util.getConfig("isVidyo", true))){
			WebRTCApp.setVideoEl(wMgr.agentVideoElement, wMgr.clientVideoElement);
			WebRTCApp.setTagServerUrl( com.inq.flash.client.control.FlashPeer.getVanityUrl() );
			wMgr.chatInfo.token = com.inq.utils.Util.getConfig("vidyoKeyID", "123");
		} else {
			WebRTCApp.setVideoEl(wMgr.clientVideoElement, wMgr.agentVideoElement);
			wMgr.chatInfo.authToken = token;
		}
		WebRTCApp.initialize(wMgr.chatInfo);
	}
};
/**
 * @description processing the call started event from kurento room App
 */

com.inq.flash.client.control.WebRTCMgr.processCallStarted = function () {
	var callMesg = "";
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var pm = com.inq.flash.client.control.PersistenceManager;
	var toggleEl = wMgr.toggleElState;
	toggleEl(wMgr.webCallCanvas,true);
	toggleEl(wMgr.webCallConnecting, false);
	toggleEl(wMgr.webCallInProgress, true);
	toggleEl(wMgr.webCallEndCallBtn, true);
	toggleEl(wMgr.webCallStartCallBtn, false);
	toggleEl(wMgr.webCallRestartBtn, false);
	toggleEl(wMgr.webCallError, false);
	toggleEl(wMgr.webCallRecon, false);
	toggleEl(wMgr.webCallPDen, false);
	if (wMgr.webCallStatus == "restarted") {
		callMesg =
			com.inq.utils.Util.getConfig("webCallRestarted", "Customer rejoined after dropping from the call.");
	}
	else {
		callMesg =
			com.inq.utils.Util.getConfig("webCallStarted", "Customer joined the Call.");
	}

	wMgr.sendWebCallMessage(callMesg, wMgr.webCallStatus == "started" ? wMgr.WEBCALL_CONNECTED
		: wMgr.WEBCALL_RECONNECTED);
	wMgr.webCallStatus = "progress";
	pm.SetValue(WEB_CALL_STARTED, 1);
	pm.SetValue(WEB_CALL_URL, wMgr.chatInfo.kurentoAppServerUrl);
	pm.SetValue(WEB_CALL_AUTH_TOKEN, wMgr.chatInfo.authToken);
	wMgr.ringSnd && wMgr.ringSnd.audio.pause();

};

/**
 * @description processing the call end event from kurento room App
 */
 com.inq.flash.client.control.WebRTCMgr.processCallEnded = function () {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var pm = com.inq.flash.client.control.PersistenceManager;
	if(wMgr.webCallStatus == "callerror") {
		return;
	}

	var toggleEl = wMgr.toggleElState;
	toggleEl(wMgr.webCallEndCallBtn, false);
	toggleEl(wMgr.webCallInProgress, false);
	toggleEl(wMgr.webCallConnecting, false);

	//com.inq.flash.client.control.WebRTCMgr.webCallStartCallBtn.setVisible(true);
	var msg = com.inq.utils.Util.getConfig("webCallEnded", "Call ended.");
	if(wMgr.webCallStatus == "progress" || wMgr.webCallStatus == "ended") {
		wMgr.sendWebCallEndMessage(msg, wMgr.isCustomerEndsChat);
	} else if(wMgr.webCallStatus == "started") {
		wMgr.sendWebCallEndMessage(WebRTCMgr.CALL_LEFT_MSG, wMgr.isCustomerEndsChat,true);
	} else if(wMgr.webCallStatus == "restarted") {
		wMgr.sendWebCallMessage(WebRTCMgr.CALL_WS_MSG, wMgr.WEBCALL_ERROR);
	}
	wMgr.webCallStatus = "ended";
	pm.SetValue(WEB_CALL_STARTED, 0);
	pm.SetValue(WEB_CALL_MODE, "");
	wMgr.isCustomerEndsChat = false;
	wMgr.isEngaged = false;
	wMgr.ringSnd && wMgr.ringSnd.audio.pause();
	if(wMgr.closeOnEnd) {
		com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
	}
};

/**
 * @description setting the error element with various error messages
 * @param errorString String
 */
com.inq.flash.client.control.WebRTCMgr.onError = function (errorString, reason) {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var wApp = window.top.WebRTCApp || window.WebRTCApp;
	if (wMgr.webCallStatus == "progress" || wMgr.webCallStatus == "restarted" || wMgr.webCallStatus == "ended") {
		return;
	}
	wMgr.ringSnd && wMgr.ringSnd.audio.pause();
	var pd = false;
	var es = "";
	switch(errorString) {
		case "perDenied":
			pd = true;
			es = "Chat Interface failed to access Microphone.";
			if(wMgr.automatonParams) {
				com.inq.flash.client.control.XFrameWorker.setEngageParameters(wMgr.automatonParams);
			}
			break;
		case "AI":
			es = "Agent failed to setup a WebRTC call.";
			break;
		case "LC":
			es = "CI Lost Web Socket Connectivity."; break;
		case "WE":
			es = "CI failed to setup WebRTC call."; break;
		case "TO":
			es = "WebRTC call ended due to room/media Error."; break;
		case "IC":
			es = "Customer failed to setup ICE Connection."; break;
		default:
			es = "Unexpected connection error.";
	}

	var cusText = com.inq.utils.Util.getConfig( pd ? "webCallPerErr"
		: "webCallError", es);
	var err = wMgr.setErrorText(null, cusText, false, pd ? true : false);
	com.inq.flash.client.control.PersistenceManager.SetValue(WEB_CALL_STARTED, 0);
	//com.inq.flash.client.control.PersistenceManager.SetValue("ewcall", "");
	wMgr.isCustomerEndsChat = false;
	wMgr.isEngaged = false;
	wMgr.webCallStatus = "callerror";
	wApp && wApp.closeRoom();
	if(!!wMgr.isIOSSDK() && !errorString == "perDenied") {
		wMgr.isIOSSDK().postMessage("endcall");
	}
	err+=(reason?(""+ reason):"");
	wMgr.sendWebCallMessage(err, pd ? wMgr.PERM_DENIED:wMgr.WEBCALL_ERROR);
	wMgr.disSnd && wMgr.disSnd.audio.play();
};

com.inq.flash.client.control.WebRTCMgr.setErrorText = function(errorString, customText, reconnect, denied) {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var text = typeof errorString == "string" ? errorString : customText;
	var toggleEl = wMgr.toggleElState;
	toggleEl(wMgr.webCallConnecting, false);
	toggleEl(wMgr.webCallInProgress, false);
	toggleEl(wMgr.webCallEndCallBtn, false);
	if(reconnect && wMgr.webCallRecon) {
		toggleEl(wMgr.webCallRecon, true);
		return text;
	} else {
		if(denied && wMgr.webCallPDen) {
			toggleEl(wMgr.webCallPDen, true);
			return text;
		} else {
			toggleEl(wMgr.webCallError, true);
			//RTDEV-19522 Disable buttons on the call screen to exclude them from tab order.
			toggleEl(wMgr.webCallEndCallBtn, false);
			toggleEl(wMgr.muteBtn, false);
			toggleEl(wMgr.unmuteBtn, false);
			//RTDEV-19522 Announcement for error screen and placing focus on "Contact Us" button
			com.inq.aria.AriaMsg.addAriaMsg(wMgr.webCallError._div.innerText);
			var contactUsBtn = Application.application.getButton("redirectToContactUs");
			if (contactUsBtn && contactUsBtn._img) {
				contactUsBtn._img.focus();
			}
		}
	}
	if (js.Boot.__instanceof(wMgr.webCallError, com.inq.ui.Text)) {
		wMgr.webCallError.setText(text);
	}
	return text;
};

/**
 *  This method will be invoked when ever there is an error and need to display the reconnecting canvas.
 *  stateOnly variable decides if it needs to leave the room and rejoin
 * @param errorString
 * @param stateOnly
 */
com.inq.flash.client.control.WebRTCMgr.onDisconnect = function (errorString, stateOnly) {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if(wMgr.webCallStatus == "ended" || wMgr.webCallStatus == "callerror") return;
	wMgr.setErrorText(errorString, "", true);
	if(!stateOnly) {
		if(window.WebRTCApp) {
			window.WebRTCApp.leaveRoom();
		} else {
			window.top.WebRTCApp.leaveRoom();
		}
		clearTimeout(wMgr.timerID);
		wMgr.timerID = setTimeout(wMgr.onTimeout, 3000);
	}
};

com.inq.flash.client.control.WebRTCMgr.onRestart = function (msg){
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if(window.WebRTCApp) {
		window.WebRTCApp.leaveRoom();
	} else {
		window.top.WebRTCApp.leaveRoom();
	}
	wMgr.setErrorText(msg, "", true);
	wMgr.incrementCount();
};

com.inq.flash.client.control.WebRTCMgr.onTimeout = function (){
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if (com.inq.flash.client.control.PersistenceManager.GetValue(WEB_CALL_STARTED, 0) === 1) {
		if(wMgr.retryCount<5) {
			wMgr.webCallStatus = "restarted";
			wMgr.incrementCount();
			wMgr.joinCall(wMgr.chatInfo.kurentoAppServerUrl, wMgr.chatInfo.authToken);
			wMgr.retryCount++;
		} else {
			wMgr.retryCount = 0;
			wMgr.webCallStatus = "callerror";
			wMgr.onError("TO");
		}
	}
};

/**
 * @description This method will be called upon loading the kms libraries
 */

com.inq.flash.client.control.WebRTCMgr.onKMSLoad = function (){
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	if(wMgr.isEngaged) {
		/*
		 * RTDEV-19317
		 * Set focus on the EndCall button of the Call dialog when the user clicks the "Call us" button
		 * on the PCS page.
		 */
		var endCallBtn = Application.application.getButton("btnEndCallA");
		if (endCallBtn && endCallBtn._img) {
			endCallBtn._img.focus();
		}
		wMgr.engageCall(wMgr.automatonParams);
	} else {
		wMgr.sendStartCallMessage();
	}
};

com.inq.flash.client.control.WebRTCMgr.sendStartCallMessage = function (){
	com.inq.flash.client.control.WebRTCMgr.sendWebCallMessage((com.inq.utils.Util.getConfig("isVidyo", true)?"true":"false")+"," + (com.inq.flash.client.control.WebRTCMgr.isAudioOnlyWebCall() ? "false" : "true") + "," + com.inq.flash.client.control.FlashPeer.getVanityUrl() + "," + com.inq.utils.Util.getConfig("appKeyId", "123") + "," + com.inq.utils.Util.getConfig("webCallStart", "Start call"), com.inq.flash.client.control.WebRTCMgr.WEBCALL_REQUESTED);
};

com.inq.flash.client.control.WebRTCMgr.getElement = function (id,audioOnly){
	return Application.application.getMxmlItem(audioOnly?id+"A":id);
};

com.inq.flash.client.control.WebRTCMgr.toggleElState = function (el,state){
	if(el) {
		el.setVisible(state);
	}
};

com.inq.flash.client.control.WebRTCMgr.incrementCount = function () {
	com.inq.flash.client.control.WebRTCMgr.webcallCounter++;
	com.inq.flash.client.control.WebRTCMgr.chatInfo['counter'] =
		com.inq.flash.client.control.WebRTCMgr.webcallCounter;
};

com.inq.flash.client.control.WebRTCMgr.resetElState = function () {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	var toggleEl = wMgr.toggleElState;
	toggleEl(wMgr.webCallStartCallBtn, true);
	toggleEl(wMgr.webCallError, false);
	toggleEl(wMgr.webCallConnecting, false);
	toggleEl(wMgr.webCallPDen, false);
	toggleEl(wMgr.webCallRecon, false);
	wMgr.webCallStatus = "";
}

com.inq.flash.client.control.WebRTCMgr.isWebRTCCapable = function () {
	var wMgr = com.inq.flash.client.control.WebRTCMgr;
	return typeof (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia) == "function" || wMgr.isIOSSDK() != undefined || wMgr.getAndSDKInst() != undefined;
};

com.inq.flash.client.control.WebRTCMgr.setCallQueue = function () {
	if(WebRTCMgr.webCallStatus == "started" && !WebRTCMgr.isQueued) {
		WebRTCMgr.sendWebCallMessage("Call in Queue.", WebRTCMgr.CALL_QUEUED);
		WebRTCMgr.isQueued = true;
	}
};

com.inq.flash.client.control.WebRTCMgr.isIOSSDK = function() {
	var _pWin = window.parent;
	return _pWin.webkit && _pWin.webkit.messageHandlers && _pWin.webkit.messageHandlers.tcrtc;
};

com.inq.flash.client.control.WebRTCMgr.getAndSDKInst = function () {
	var _pWin = window.parent;
	return _pWin.NuanRTCSDK;
};

com.inq.flash.client.control.WebRTCMgr.getMuteBtn = function () {
	return com.inq.flash.client.control.WebRTCMgr.muteBtn;
};

com.inq.flash.client.control.WebRTCMgr.isCallStarted = function () {
	var webRTCMgr = com.inq.flash.client.control.WebRTCMgr;
	return (webRTCMgr.webCallStatus && webRTCMgr.webCallStatus != "ended" && webRTCMgr.webCallStatus != "callerror");
};

/*
 * @static
 * @public
 */

window.WebRTCMgr = com.inq.flash.client.control.WebRTCMgr;
WebRTCMgr.chatInfo  = null;
WebRTCMgr.webCallConnecting = null;
WebRTCMgr.webCallInProgress = null;
WebRTCMgr.webCallError = null;
WebRTCMgr.customerVideoElement = null;
WebRTCMgr.agentVideoElement = null;
WebRTCMgr.webCallCanvas = null;

WebRTCMgr.audioOnlyChat = true;
WebRTCMgr.webCallStatus = null;
WebRTCMgr.webcallCounter = 0;
WebRTCMgr.isCustomerEndsChat = false;
WebRTCMgr.isEngaged = false;
WebRTCMgr.automatonParams = null;
WebRTCMgr.timerID = -1;
WebRTCMgr.closeOnEnd = false;
WebRTCMgr.retryCount = 0;
WebRTCMgr.isQueued = false;

WebRTCMgr.WEBCALL_REQUESTED = "webcallRequest";
WebRTCMgr.WEBCALL_CONNECTED = "webcallConnected";
WebRTCMgr.WEBCALL_RECONNECTED = "webcallReconnected";
WebRTCMgr.WEBCALL_ENDED = "webcallEnded";
WebRTCMgr.WEBCALL_ERROR = "webcallError";
WebRTCMgr.WEBCALL_LEFT = "wcLEFT";
WebRTCMgr.PERM_DENIED = "wcDenied";
WebRTCMgr.CALL_QUEUED = "wcQueued";
WebRTCMgr.CALL_LEFT_MSG = "Customer left the call.";
WebRTCMgr.CALL_WS_MSG = "Customer lost web socket connection.";

/**
 * Stores Web call value mode when call started (WebRTC functionality)
 * stores value of URL used for WEBRTC_URL
 * @type {string}
 */
WebRTCMgr.WEBRTC_URL = "https://webrtc-test.inq.com/";

/**
 * Stores Web call value mode when call started (WebRTC functionality)
 * stores value of AC used for AUDIO_CALL
 * @type {string}
 */
WebRTCMgr.AUDIO_CALL = "AC";

/**
 * Stores Web call value mode when call started (WebRTC functionality)
 * stores value of VC used for VIDEO_CALL
 * @type {string}
 */
WebRTCMgr.VIDEO_CALL = "VC";
